const actions = {
  async getData({ commit, dispatch }, { params, query, selectedSearch }) {
    commit('tools/GET_DATA_REFRESHED_TIME_REQUESTED', true, { root: true })

    if (selectedSearch) {
      query.networkCode = selectedSearch.networkCode
      query.publisherId = selectedSearch.publisherId
    }

    const updateView = () => {
      const { baseReportName, routeName } = params
      const endpointKey = baseReportName || routeName
      return dispatch('tools/updateView', { endpointKey }, { root: true })
    }
    const setView = () => {
      const { reportPath } = query
      const haveSelectedSearch = !!(reportPath && selectedSearch)
      return haveSelectedSearch && dispatch('tools/setView', { params, query }, { root: true })
    }

    return setView() || updateView()
  },
}

export default actions
